import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Divider, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const HomeSafetyLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>  
      <Segment raised className={styles.learnMoreOverviewTextBox} >
        <p className={styles.learnMoreAccordionText} > 
          <span className={styles.learnMoreAccordionTextLink} > 
            <a href="https://www.cdc.gov/homeandrecreationalsafety/pubs/english/booklet_eng_desktop-a.pdf"
              target="_blank"
              rel="noreferrer" > 
              <Icon name='linkify' size="small" className={styles.linkifyIcon} />
              From the Centers for Disease Control and Prevention{" "} 
            </a> 
          </span>
          <br /> <br /> 
          Every year, many older adults are seriously injured from preventable falls that occur in the home due 
          to common hazards and obstructions. 
          <br /> <br /> 
          If a professional home assessment is not attainable, here is a list of things in the older adult's home
          to look out for and how to fix or address them. </p>   
      </Segment>  
      <Grid stackable className={styles.learnMoreFullDiv} >
        <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
          <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}KitchenIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >KITCHEN </p>
                <Header.Subheader>
                  <p className={styles.learnMoreAccordionText} >
                    <Divider className={styles.highlightsDivider} /> Move commonly used items to lower shelves.
                    <br /><Divider className={styles.highlightsDivider} />If the older adult must use a step stool, make sure it is one that has a sturdy 
                    bar to hold on to for support. </p> 
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}FloorsIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >FLOORS </p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                    <Divider className={styles.highlightsDivider} />  Make sure all pathways are clear.
                    <br /><Divider className={styles.highlightsDivider} /> If the home has loose rugs, remove them or use a non-slip backing to secure.
                    <br /><Divider className={styles.highlightsDivider} /> Secure all cords to the wall. </p> 
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
          <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} > 
                <Image src={`${iconRoute}BedroomIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >BEDROOMS </p>
                <Header.Subheader>  
                  <p className={styles.learnMoreAccordionText} >
                    <Divider className={styles.highlightsDivider} />Put a lamp close to the bed that is easy to reach.
                    <br /><Divider className={styles.highlightsDivider} /> Add a night-light so the older adult can have a lighted pathway when they are walking
                     to and from their bed. </p> 
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}BathroomIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >BATHROOMS  </p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                    <Divider className={styles.highlightsDivider} /> Put non-slip rubber mats or self-stick strips on the floor of the tub and shower.
                    <br /><Divider className={styles.highlightsDivider} /> Have a professional install grab bars inside the shower and next to the toilet. </p> 
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched className={styles.highlightsItemRow} style={{display: 'grid'}}>
          <Grid.Column stretched className={styles.hghlgtItemColFull} style={{justifyContents: 'center'}} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}StairsIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >STAIRS, STEPS, & RAMPS </p>
                <Header.Subheader>  
                  <p className={styles.learnMoreAccordionText} >
                    <Divider className={styles.highlightsDivider} />Make sure steps are clear of any objects.
                    <br /><Divider className={styles.highlightsDivider} /> Fix any loose or uneven steps.
                    <br /><Divider className={styles.highlightsDivider} />Have an electrician add or fix lighting over the stairway and make sure there is a 
                      light switch at the top and bottom of the stairs.
                    <br /><Divider className={styles.highlightsDivider} />If the steps are carpeted, make sure the carpet is firmly attached to each step.
                    <br /><Divider className={styles.highlightsDivider} />Steady handrails should be on both sides of the stairs, fix any loose handrails 
                      or install in new ones. </p> 
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips for Home Safety </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}HomeSafetyInfoOne.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(HomeSafetyLearnMore);
